export enum FeatureToggle {
  IncentiveBudgets = 'rt_ipp_incentive_budgets',
}
